import * as React from 'react';
import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import IconButton from '@mui/material/IconButton';
import MenuIcon from '@mui/icons-material/Menu';
import { Avatar, Breadcrumbs, Link, Stack } from '@mui/material';
import { useCallback, useEffect, useState } from 'react';
import { useLocation, Link as RouterLink } from 'react-router-dom';
import NavigateNextIcon from '@mui/icons-material/NavigateNext';
import SearchIcon from '@mui/icons-material/Search';
import { Tooltip } from '@mui/material';
import GlobalSearch from '../components/GlobalSearch';
import NotificationsBell from '../components/NotificationsBell';

export default function ButtonAppBar(props) {
    const { onMobileNavOpen } = props;
    const location = useLocation();
    const [searchOpen, setSearchOpen] = useState(false);

    // Ctrl+Space to open search
    const handleGlobalKeyDown = useCallback((e) => {
        if ((e.ctrlKey || e.metaKey) && e.key === ' ') {
            e.preventDefault();
            setSearchOpen(true);
        }
    }, []);

    useEffect(() => {
        window.addEventListener('keydown', handleGlobalKeyDown);
        return () => window.removeEventListener('keydown', handleGlobalKeyDown);
    }, [handleGlobalKeyDown]);

    return (<>
        <Box sx={{ flexGrow: 1, borderBottom: '1px solid #e1e3ea' }}>
            <AppBar className="headr-main" position="sticky" elevation={0} sx={{ backgroundColor: 'white', top: 0, zIndex: 1100 }}>
                <Toolbar>
                    <IconButton
                        size="large"
                        edge="start"
                        color="inherit"
                        aria-label="menu"
                        onClick={onMobileNavOpen}
                        sx={{
                            mr: 2,
                            display: {
                                lg: 'none'
                            }
                        }}
                    >
                        <MenuIcon />
                    </IconButton>
                    <Box sx={{ flexGrow: 1, ml: 2 }}>
                        <Breadcrumbs
                            separator={<NavigateNextIcon fontSize="small" />}
                            aria-label="breadcrumb"
                        >
                            <Link
                                underline="hover"
                                color="inherit"
                                component={RouterLink}
                                to="/dashboard"
                                sx={{ fontSize: '14px', fontWeight: 500 }}
                            >
                                Dashboard
                            </Link>
                            {location.pathname
                                .split('/')
                                .filter((path) => path && path !== 'dashboard')
                                .map((path, index, array) => {
                                    const routeTo = `/dashboard/${array.slice(0, index + 1).join('/')}`;
                                    const isLast = index === array.length - 1;
                                    const title = path
                                        .replace(/-/g, ' ')
                                        .replace(/\b\w/g, (l) => l.toUpperCase());

                                    return isLast ? (
                                        <Typography
                                            key={path}
                                            color="textPrimary"
                                            sx={{ fontSize: '14px', fontWeight: 600 }}
                                        >
                                            {title}
                                        </Typography>
                                    ) : (
                                        <Link
                                            key={path}
                                            underline="hover"
                                            color="inherit"
                                            component={RouterLink}
                                            to={routeTo}
                                            sx={{ fontSize: '14px', fontWeight: 500 }}
                                        >
                                            {title}
                                        </Link>
                                    );
                                })}
                        </Breadcrumbs>
                    </Box>
                    <Stack direction="row" spacing={2} alignItems="center">
                        {/* Global Search */}
                        <Tooltip title="Search (Ctrl+Space)">
                            <IconButton
                                onClick={() => setSearchOpen(true)}
                                sx={{ color: 'text.secondary' }}
                            >
                                <SearchIcon />
                            </IconButton>
                        </Tooltip>
                        <NotificationsBell />

                        <Avatar src={'/favicon-sow.png'} sx={{ objectFit: 'contain', bgcolor: 'transparent' }} />
                    </Stack>
                </Toolbar>
            </AppBar>
        </Box >
        <GlobalSearch open={searchOpen} onClose={() => setSearchOpen(false)} />
    </>
    );
}
